// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: tools/telemetry_api/lcmtypes/telemetry_error_code_t.lcm
import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmEnumMsg from "@skydio/lcm/src/enum";

enum option_t {
  SUCCESS = 0,
  TELEMETRY_API_ERROR = 1000,
  NOT_FOUND = 4000,
  LOG_LOCALIZER_ERROR = 5000,
  RUNLOG_DECODING_ERROR = 5100,
  AUTH_EXCEPTION = 6000,
}

export class telemetry_error_code_t extends LcmEnumMsg {
  public static override option_t = option_t;
  private static _hash = Long.fromString("11999453122282051735", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (telemetry_error_code_t._packed_fingerprint === undefined) {
      telemetry_error_code_t._packed_fingerprint = telemetry_error_code_t._get_hash_recursive([]);
    }
    return telemetry_error_code_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(telemetry_error_code_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = telemetry_error_code_t._hash;
    tmp_hash = tmp_hash.shl(1).add(tmp_hash.shru(63));
    return tmp_hash;
  }

  public override decode(array: Uint8Array): telemetry_error_code_t {
    const decoder = new Decoder(
      new DataView(array.buffer, array.byteOffset, array.byteLength)
    );
    const hash = decoder.decode_hash();
    if (!hash.equals(telemetry_error_code_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, telemetry_error_code_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  // Recursively decode a message with the supplied decoder.
  public override decode_one(decoder: Decoder): telemetry_error_code_t {
    this.value = decoder.decode_int32_t();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    return 4;
  }

  public override encode(): ArrayBufferLike {
    const total_size = this._get_encoded_size();
    const encoder = new Encoder(total_size);
    this.encode_one(encoder);
    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int32_t(this.value);
  }

  // static constructors
  static get SUCCESS() {
    return new telemetry_error_code_t(option_t.SUCCESS);
  }
  static get TELEMETRY_API_ERROR() {
    return new telemetry_error_code_t(option_t.TELEMETRY_API_ERROR);
  }
  static get NOT_FOUND() {
    return new telemetry_error_code_t(option_t.NOT_FOUND);
  }
  static get LOG_LOCALIZER_ERROR() {
    return new telemetry_error_code_t(option_t.LOG_LOCALIZER_ERROR);
  }
  static get RUNLOG_DECODING_ERROR() {
    return new telemetry_error_code_t(option_t.RUNLOG_DECODING_ERROR);
  }
  static get AUTH_EXCEPTION() {
    return new telemetry_error_code_t(option_t.AUTH_EXCEPTION);
  }

  public override value: option_t;

  constructor(value?: option_t) {
    super();
    this.value = value ?? option_t.SUCCESS;
  }

  public override get name(): string {
    return option_t[this.value]!;
  }
}